import styled from 'styled-components';

export const Container = styled.section`
    width: 95vw;  /* Ocupa 100% da largura da viewport */
    max-width: 95vw;  /* Garante que o container não seja limitado por nenhum max-width */
    margin: 0;  /* Remove margens */
    padding: 20px;  /* Adiciona padding interno */
    box-shadow: 0 0 1em #6c757d;
    display: flex;
    flex-direction: column;
    text-align: center !important;
        display: flex;
    flex-direction: column;
    align-items: center;  /* Centraliza o conteúdo horizontalmente */
    justify-content: center;  /* Centraliza o conteúdo verticalmente */
    text-align: center;  /* Centraliza o texto dentro do container */
`;

export const ConteudoTitulo = styled.section`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
`;

export const BotaoAcao = styled.section`
    margin: 25px 0px;
`;

export const ButtonSuccess = styled.button`
    background-color: #fff;
    color: #198754;
    border: 1px solid #198754;
    padding: 10px 15px;
    border-radius: 4px;
    margin-left: 10px;
    cursor: pointer;
    font-size: 16px;
    :hover{
        background-color: #157347;
        color: #fff;
    }
`;

export const Input = styled.input`
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 6px;
    margin-bottom: 16px;
    resize: vertical;
`;

export const ButtonPrimary = styled.button`
    background-color: #fff;
    color: #0d6efd;
    padding: 10px 15px;
    border: 1px solid #0d6efd;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    :hover{
        background-color: #0d6efd;
        color: #fff;
    }
`;

export const ButtonDanger = styled.button`
  background-color: #ff6961;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-left: 30px;

  &:hover {
    background-color: darkred;
  }
`;

export const ButtonWarning = styled.button`
    background-color: #fff;
    color: #ffc107;
    padding: 10px 15px;
    border: 1px solid #ffc107;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    :hover{
        background-color: #ffc107;
        color: #fff;
    }
`;

export const Titulo = styled.h1`
    color: #3e3e3e;
    font-size: 28px;
    margin-bottom: 20px;
`;

export const Table = styled.table`
    width: 100%;
    
    border-collapse: collapse;
    th {
        background-color: #a9a9a9;
        color: #3e3e3e;
        padding: 12px;
        text-align: center;
    }
    td {
        background-color: #f6f6f6;
        color: #3e3e3e;
        padding: 10px;
    }
    tr:nth-child(even) {
        background-color: #e9ecef;
    }
`;
